// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__LKAT6","left":"Virtual_left__kDfVx","wrapper":"Virtual_wrapper__NOkZI"};